import {
  Component,
  OnInit,
  OnChanges,
  ErrorHandler,
  HostListener,
  ComponentFactoryResolver,
} from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { find, findIndex, map } from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { AngularFirestore, QuerySnapshot, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import * as firebase from 'firebase';

// Set the http options
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization:
      // tslint:disable-next-line: max-line-length
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJuYW1lIjoibXRnZXZlbnRzX2FwcCIsInN1YmNyaXB0aW9uS2V5IjoiYzJkOGJkMDQtMGY0Yy00N2FlLWI4NjAtMzBlODM1MTRjYmQ3In0sImlhdCI6MTU2NDQ2ODE3OX0.VjiFlZInzMnQeRxOlRmNg-7EZ97L1giBwo3Nbu8PL_M',
  }),
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'n00bcoM';

  public showCheckIn = false;
  public showAttendeeList = false;
  public roomInput = '';
  public eventRoomsList = true;
  public reportedMatchesFilteredRound = null;
  public showReportTable = false;
  public hideReportedMatches = true;
  public resultSlip = {
    reporterWon: false,
    opponentWon: false,
    reporterGW: null,
    opponentGW: null,
    gamesDrawn: null,
    isReportedWithApp: false,
    round: null,
    errorMessage: ''
  };
  public displayName = '';
  public chatMessage = '';
  public chatMessages: Observable<any[]>;
  public chatMinimized = true;
  public chatColor: string;
  public chatAnnouncement = false;
  public bingoAnnouncement = false;
  public secretCode = '';
  public isReporting = false;
  public reportTable: number;
  public reportResult = '';
  public adminMode = false;
  public adminUpdateRooms = false;
  public timeMinimized = true;
  public bracketSelected = false;
  public showChatMessages = true;
  public showMatchReports = true;
  public showAnnouncements = true;
  public showBingoAnnouncements = true;
  public muteChat = false;

  public showHowto = false;
  public howtos = [
    {
      title: 'Send Chat Message',
      steps: [
        // tslint:disable-next-line: max-line-length
        'You can fetch card images by encapsulating the card name with double square brackets like this [[illusionary mask]] inside your messages.',
        // tslint:disable-next-line: max-line-length
        'Specify a specific card edition by adding a straight slash followed by the set code like this [[time walk | lea]] for Limited Edition Alpha card image.',
        // tslint:disable-next-line: max-line-length
        'You can fetch card rules by encapsulating the card name with double square brackets and a question mark like this [[?black ltus]] inside your messages.'
      ],
      gif: '',
    },
    {
      title: 'Report Match Result',
      steps: [
        'Open up the chat panel by pressing the chat icon to the top left of the screen',
        'Make sure you have stated your name in the form area in the bottom of the chat panel.',
        'Click report button in chat area',
        'Enter the table number you played at (according to pairings) in the table number input field',
        // tslint:disable-next-line: max-line-length
        'Select the number of games YOU won by pressing the 2/1/0 button next to "I won".',
        'Select the number of games OPPONENT won by pressing the 2/1/0 button next to "Opponent won".',
        'In case you had any drawn games (a game is a draw if both players lose)',
        'If all is OK, the "Report result" button will be visible and you can press it to report!',
      ],
      gif: 'app/assets/howto-report-match-result.gif',
    },
  ];

  public happeningTitle = '';
  public happeningText = '';
  public happeningTimeStart = '';
  public happeningTimeEnd = '';
  public happenings: Observable<any[]>;
  isBusy = true;
  eventDetails: any;
  rounds = [];
  roundData: any = {
    round: 0,
    matches: [],
    unpairedPlayers: [],
    status: 'No round selected',
  };
  showData = false;
  showPairings = true;
  standingsSelected = false;
  selectedRound = 0;
  filterText = '';
  standingsData: any;

  colors = [
    'yellow',
    'orange',
    'blue',
    'red',
    'greenyellow',
    'pink',
    'teal',
    'moccasin',
    'lightsalmon',
    'paleturquoise',
  ];

  private lastChatMessage = '';

  eventDoc: AngularFirestoreDocument<EventSettings>;
  eventDoc$: Observable<EventSettings>;

  eventNumber: string;
  tableUrls: Array<string>;
  attendees: Array<string>;
  demandCheckin = false;
  deckOrder = [
    ['x', 'x', 'x'],
    ['c', 'a', 'b'],
    ['b', 'c', 'a'],
    ['b', 'a', 'c'],
    ['a', 'c', 'b'],
    ['c', 'b', 'a'],
    ['b', 'a', 'c'],
    ['a', 'b', 'c'],
    ['c', 'a', 'b'],
    ['a', 'c', 'b'],
    ['b', 'a', 'c'],
    ['c', 'b', 'a'],
    ['b', 'c', 'a']
  ];
  // canvas for confetti
  // public canvas: HTMLCanvasElement;
  constructor(private http: HttpClient, private db: AngularFirestore) {
    this.chatMessages = db
      .collection('/chat', (ref) => ref
        .orderBy('timestamp', 'asc'))
      .valueChanges();

    this.happenings = this.db
      .collection('/happenings', (ref) => ref
        .orderBy('start', 'asc'))
      .valueChanges();

    this.eventDoc = this.db.doc<EventSettings>('/eventSettings/appSettings');
    this.eventDoc$ = this.eventDoc.valueChanges();
  }

  ngOnInit() {
    // this.confettiRain();
    this.eventDoc$.subscribe((doc: EventSettings) => {
      this.eventNumber = doc.eventId;
      // this.eventNumber = '001689';
      this.tableUrls = doc.rooms;
      this.attendees = doc.attendees;
      console.log('rooms', this.tableUrls);
      console.log('event id', this.eventNumber);
      this.getEventData().then((data: any) => {
        this.eventDetails = data;
        // sort player list
        this.eventDetails.players.sort((a, b) =>
          a.name.full < b.name.full ? -1 : b.name.full < a.name.full ? 1 : 0
        );
        console.log('Event data: ', this.eventDetails);
        this.rounds.length = 0;
        for (let i = 1; i <= this.eventDetails.roundsToPlay; i++) {
          const round = {
            num: i,
            selected: false,
          };
          if (i === this.eventDetails.status.activeRound) {
            console.log('Active Round: ', this.eventDetails.status.activeRound);
            round.selected = true;
            this.selectedRound = i;
            this.updateRoundData();
          }
          this.rounds.push(round);
        }
        this.isBusy = false;
      });
    });


    console.log('Checking for stored color code');
    if (localStorage.getItem('chatColor')) {
      console.log(
        '... color code found. (' + localStorage.getItem('chatColor') + ')'
      );
      this.chatColor = localStorage.getItem('chatColor');
    } else {
      console.log('... no color found, setting one.');
      localStorage.setItem(
        'chatColor',
        this.colors[Math.floor(Math.random() * 10)]
      );
      this.chatColor = localStorage.getItem('chatColor');
      console.log('... color code set (' + this.chatColor + ')');
    }
    console.log('Checking for store display name');
    if (localStorage.getItem('displayName')) {
      console.log('... name found, setting it in the chat');
      this.displayName = localStorage.getItem('displayName');
    }

    this.chatMessages.subscribe((data) => {
      console.log('new message');
      const lastIndex = data.length - 1;
      const lastMessage = data[lastIndex];
      console.log(lastMessage);
      if (this.lastChatMessage !== lastMessage.message) {
        this.lastChatMessage = lastMessage.message;
        if (lastMessage.type === 'announcement') {
          this.chatMinimized = false;
          const audio = new Audio('app/assets/new-announcement-chat.wav');
          console.log('play the damn sound');
          audio.play();
        }
        if (lastMessage.type === 'normal') {
          const audio = new Audio('app/assets/new-normal-chat.wav');
          if (!this.muteChat) {
            console.log('play the damn sound');
            audio.play();
          } else {
            console.log('NOT playing the damn sound, user have muted');
          }
        }
        if (lastMessage.type === 'match-result') {
          const audio = new Audio('app/assets/new-match-result-chat.wav');
          audio.play();
          // this.confettiRain();
        }
      } else {
        console.log('Duplicate message announcement, supress the sound');
      }
    });
    console.log('NG Init');

    setInterval(() => {
      this.getEventData().then((data: any) => {
        this.eventDetails = data;
        // sort player list
        this.eventDetails.players.sort((a, b) =>
          a.name.full < b.name.full ? -1 : b.name.full < a.name.full ? 1 : 0
        );
      });
    }, 10000);
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === ' ') {
      this.secretCode = '';
    } else {
      this.secretCode = this.secretCode + event.key;
      if (this.secretCode === 'togfather') {
        this.adminMode = true;
      }
    }
  }

  resetSlip() {
    this.resultSlip.reporterWon = false;
    this.resultSlip.opponentWon = false;
    this.resultSlip.reporterGW = null;
    this.resultSlip.opponentGW = null;
    this.resultSlip.gamesDrawn = null;
    this.reportTable = null;
    this.resultSlip.isReportedWithApp = false;
    this.resultSlip.errorMessage = '';
  }
  getEventData() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>('https://api.mtgevents.app/events/' + this.eventNumber, {
          headers: httpOptions.headers,
        })
        .subscribe((data) => {
          console.log('updated event data');
          resolve(data.eventData);
        });
    });
  }
  deselectAll() {
    this.rounds.forEach((round) => {
      round.selected = false;
    });
    this.standingsSelected = false;
    this.bracketSelected = false;
  }
  updateRoundData() {
    if (this.standingsSelected) {
      this.showData = true;
      this.standingsData = JSON.parse(
        JSON.stringify(this.eventDetails.players)
      );
      this.standingsData.sort((a, b) =>
        a.stats.ogwp > b.stats.ogwp ? -1 : b.stats.ogwp > a.stats.ogwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.gwp > b.stats.gwp ? -1 : b.stats.gwp > a.stats.gwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.omwp > b.stats.omwp ? -1 : b.stats.omwp > a.stats.omwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.mp > b.stats.mp ? -1 : b.stats.mp > a.stats.mp ? 1 : 0
      );

      let rank = 1;
      this.standingsData.forEach((player) => {
        player.rank = rank;
        rank++;
      });
    } else {
      console.log('selected round index:', this.selectedRound);
      console.log(
        'event status:',
        this.eventDetails.status.text +
        ' (' +
        this.eventDetails.status.code +
        ')'
      );
      if (
        this.eventDetails.round.findIndex(
          (x) => x.round === this.selectedRound
        ) === -1
      ) {
        console.log('... no round data, hide table and show message instead');
        this.showData = false;
      } else if (
        this.eventDetails.status.activeRound === this.selectedRound &&
        this.eventDetails.status.code < 2
      ) {
        console.log(
          '... active round is not paired, hide table and show message instead'
        );
        this.showData = false;
      } else {
        this.showData = true;
        this.roundData = JSON.parse(
          JSON.stringify(
            this.eventDetails.round[
            this.eventDetails.round.findIndex(
              (x) => x.round === this.selectedRound
            )
            ]
          )
        );
        // console.log("round data", this.roundData);
      }
    }
  }
  getPercentage(value) {
    const newValue = value * 100;
    return newValue.toFixed(2) + '%';
  }
  onKeysdown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendChatMessage();
      this.chatMessage = '';
    }
  }
  sendChatMessage() {
    console.log('About to send message');
    if (
      (!this.isReporting && this.displayName.length > 0) ||
      (this.isReporting && this.newReportFormValid())
    ) {
      if (
        (!this.isReporting && this.chatMessage.length > 0) ||
        (this.isReporting && this.newReportFormValid())
      ) {
        localStorage.setItem('displayName', this.displayName);
        // let timestamp = new Date().getTime();
        const timestamp = firebase.firestore.FieldValue.serverTimestamp;
        const data: any = {
          message: this.chatMessage,
          type: 'normal',
          displayName: this.displayName,
          displayColor: this.chatColor,
          timestamp: timestamp(),
        };
        if (this.chatAnnouncement) {
          data.type = 'announcement';
        }
        if (this.isReporting) {
          data.type = 'match-result';
          // data.result = this.reportResult;
          data.result = this.resultSlip;
          data.table = this.reportTable;
          data.round = this.eventDetails.status.activeRound;
        }
        console.log('check for cards in chat message');
        this.checkForCards(this.chatMessage);
        console.log('send message to firebase');
        this.db
          .collection('chat')
          .add(data)
          .then((response) => {
            this.db
              .collection('chat')
              .doc(response.id)
              .update({ docId: response.id });
            this.chatAnnouncement = false;
            this.bingoAnnouncement = false;
            this.chatMessage = '';
            this.isReporting = false;
            this.reportResult = '';
            this.reportTable = undefined;
            this.resetSlip();
          });
      }
    } else {
      console.log('... isReporting: ', this.isReporting);
      console.log('... formValid: ', this.newReportFormValid());
      console.log('... displayName: ', this.displayName);
      console.log('... message: ', this.chatMessage);
    }
  }
  newReportFormValid() {

    if (this.displayName === null || this.displayName === '') {
      console.log('name is not set');
      this.resultSlip.errorMessage = 'You have not stated your name, press cancel and enter your name in the chat form and then try again';
      return false;
    } else if (this.reportTable < 1 || this.reportTable > 50 || !this.reportTable) {
      console.log('report table below 1');
      this.resultSlip.errorMessage = 'You need to state table to be able to report';
      return false;
    } else if (this.resultSlip.reporterGW === null || this.resultSlip.opponentGW === null) {
      console.log('Both players need gw');
      this.resultSlip.errorMessage = 'You need to report game wins for both players';
      return false;
    } else if (this.resultSlip.reporterGW === 2 && this.resultSlip.opponentGW === 2) {
      console.log('both players cant win 2');
      this.resultSlip.errorMessage = 'Both players cant win 2 games';
      return false;
    }

    this.resultSlip.errorMessage = 'All looks good, press report!';
    return true;

  }
  addHappening() {
    const data = {
      title: this.happeningTitle,
      text: this.happeningText,
      start: this.happeningTimeStart,
      end: this.happeningTimeEnd,
    };
    this.db
      .collection('happenings')
      .add(data)
      .then((response) => {
        this.db
          .collection('happenings')
          .doc(response.id)
          .update({ docId: response.id });
        this.happeningTitle = '';
        this.happeningText = '';
        this.happeningTimeStart = '';
        this.happeningTimeEnd = '';
      });
  }
  deleteHappening(id) {
    this.db.collection('happenings').doc(id).delete();
  }
  deleteChatMessage(id) {
    this.db.collection('chat').doc(id).delete();
  }
  bingoAnnouncementToggle(bingoAnnouncement) {
    console.log(bingoAnnouncement);
  }
  markAsReported(docId) {
    this.db.collection('chat').doc(docId).update({ 'result.isReportedWithApp': true }).then(response => {
      console.log(response);
    });
  }
  hasCheckedIn() {
    if (localStorage.getItem('checkin')) {
      const value = localStorage.getItem('checkin');
      if (value === 'spectator') {
        return true;
      }
      if (this.checkIfCheckedIn(value)) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }
  checkIn(type: string) {
    if (type === 'spectator') {
      localStorage.setItem('checkin', 'spectator');
    } else if (type === 'participant') {
      this.showAttendeeList = true;
    } else {
      localStorage.setItem('checkin', type);
      this.db.collection('eventSettings').doc('appSettings').update({
        attendees: firebase.firestore.FieldValue.arrayUnion(type)
      });
    }
  }
  checkIfCheckedIn(name: string) {
    const index = this.attendees.findIndex(x => x === name);
    if (index > -1) {
      return true;
    }
    return false;
  }
  startCheckIn() {
    this.db.collection('eventSettings').doc('appSettings').update({
      checkInStarted: true
    });
  }

  fireConfetti(particleRatio, opts) {
  }
  // confettiRain() {
  //   let that = this;
  //   const count = 200;
  //   const defaults = {
  //     origin: {
  //       y: 1,
  //       x: 1
  //     }
  //   };
  //   console.log("Confetti Rain!");
  //   function fire(particleRatio, opts) {
  //     confetti.create(that.canvas)(
  //     Object.assign({}, defaults, opts, {
  //       particleCount: Math.floor(count * particleRatio),
  //     })
  //   );
  //   }

  //   fire(0.25, {
  //     spread: 26,
  //     startVelocity: 55,
  //   });
  //   fire(0.2, {
  //     spread: 60,
  //   });
  //   fire(0.35, {
  //     spread: 100,
  //     decay: 0.91,
  //   });
  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 25,
  //     decay: 0.92,
  //   });
  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 45,
  //   });
  // }

  private async checkForCards(message: string) {
    // store the message
    console.log(message);
    // check for cardname
    if (message.indexOf('[[') > -1 && message.indexOf(']]') > -1) {
      const cardNamesRaw = message.match(/\[\[.*?\]\]/g);
      const cards = [];
      console.log(cardNamesRaw);
      cardNamesRaw.forEach((cardName: string) => {
        console.log('cardNameRaw', cardName);
        const cardObj = {
          searchString: cardName.match(/\[\[([^)]+)\]\]/)[1].trim(),
          setString: '',
          searchRules: false,
          searchSet: false
        };
        if (cardObj.searchString.indexOf('?') > -1) {
          cardObj.searchRules = true;
          cardObj.searchString = cardObj.searchString.substring(1);
        }
        if (cardObj.searchString.indexOf('|') > -1) {
          cardObj.searchSet = true;
          cardObj.setString = cardObj.searchString.substring(cardObj.searchString.lastIndexOf('|') + 1).trim();
          cardObj.searchString = cardObj.searchString.substring(0, cardObj.searchString.indexOf('|')).trim();
        }
        console.log('card name:', cardObj.searchString);
        cards.push(cardObj);
      });

      cards.forEach(cardObj => {
        // fetch card data
        this.fetchScryfallData(cardObj).then((response: any) => {
          console.log(response);
          if (response.status === 'success') {
            this.db
              .collection('chat')
              .add(response.message)
              .then((serverResponse) => {
                this.db
                  .collection('chat')
                  .doc(serverResponse.id)
                  .update({ docId: serverResponse.id });
              });
          }
        });
      });
    }
  }
  private fetchScryfallData(cardObj: any) {
    return new Promise((resolve, reject) => {
      // https://api.scryfall.com/cards/named?fuzzy=black+lotus
      // https://api.scryfall.com/cards/f2b9983e-20d4-4d12-9e2c-ec6d9a345787/rulings
      // get card data
      let url = 'https://api.scryfall.com/cards/named?fuzzy=' + encodeURIComponent(cardObj.searchString);
      if (cardObj.searchSet) {
        url += '&set=' + cardObj.setString;
      }
      this.http.get(url).toPromise()
        .then((cardData: any) => {
          console.log('Card Data', cardData);
          const englishCardName = cardData.name;
          if (cardObj.searchRules && cardData.id) {
            // fetch card ruling
            this.http.get('https://api.scryfall.com/cards/' + cardData.id + '/rulings').toPromise()
              .then(rulings => {
                const timestamp = firebase.firestore.FieldValue.serverTimestamp;
                resolve({
                  status: 'success',
                  message: {
                    card_name: englishCardName,
                    type: 'scryfall-rules',
                    content: rulings,
                    sender: 'scryfall-robot',
                    timestamp: timestamp()
                  }
                });
              })
              .catch(error => {
                reject({
                  status: 'error',
                  message: error
                });
              });
          } else {
            const timestamp = firebase.firestore.FieldValue.serverTimestamp;
            resolve({
              status: 'success',
              message: {
                card_name: englishCardName,
                type: 'scryfall-image',
                content: cardData.image_uris.normal,
                sender: 'scryfall-robot',
                timestamp: timestamp()
              }
            });
          }
        })
        .catch(error => {
          reject({
            status: 'error',
            message: error
          });
        });
    });
  }

  setEventId() {
    const id = prompt('Enter event ID with leading zero\'s if any.');
    if (id.length === 6) {
      this.eventDoc.update({
        eventId: id
      })
        .then(() => {
          alert('Successfully changed the event id');
        })
        .catch(error => {
          alert(error);
        });
    } else {
      alert('Incorrect ID, please try again');
    }
  }

  deleteRoom(room) {
    this.eventDoc.update({
      rooms: firebase.firestore.FieldValue.arrayRemove(room)
    });
  }

  addTableUrl() {
    this.eventDoc.update({
      rooms: firebase.firestore.FieldValue.arrayUnion(this.roomInput)
    })
      .then(() => {
        this.roomInput = '';
      })
      .catch(error => {
        console.log(error);
      });
  }
}
export interface EventSettings {
  eventId: string;
  rooms: any;
  attendees: any;
  checkInStarted: boolean;
}


